import * as React from "react";
import styles from "./branches.module.scss";

const Branches = (): React.JSX.Element => <div className={styles.branchContainer}>Branches</div>;

export default Branches;
